import React, { FC } from 'react';
import {
  SectionedListCTA,
  SectionedListHeading,
  SectionedListValues,
} from './SectionedList.styles';
import { SectionedListProps } from './types';
import { Link } from 'react-router-dom';

const SectionedList: FC<SectionedListProps> = ({ sections, cta }) => (
  <div>
    {sections.map(({ heading, items }) => (
      <div key={heading}>
        {heading && <SectionedListHeading>{heading}</SectionedListHeading>}
        <SectionedListValues>
          {items.map(({ key, value }) => (
            <p key={`${key}-${value}`}>
              <span>{key}:</span>
              <span>{value}</span>
            </p>
          ))}
        </SectionedListValues>
      </div>
    ))}
    {cta && (
      <SectionedListCTA>
        <Link to={cta.href ?? '#'} onClick={cta.onClick}>
          {cta.label}
        </Link>
      </SectionedListCTA>
    )}
  </div>
);

export default SectionedList;
